export default __webpack_public_path__ + "static/media/yiddish.7cd0754d.svg";